import { useState } from "react";
import { FaFish, FaSortAmountDown, FaSortAmountUp, FaYoutube } from "react-icons/fa";
import { fishingClubIntro } from '../../data/fishingClubData';

export const Timeline = ({ data }) => {
  const [isAscending, setIsAscending] = useState(true);

  const sortedData = data
    .slice()
    .sort((a, b) =>
      isAscending
        ? a.title.localeCompare(b.title, undefined, { numeric: true })
        : b.title.localeCompare(a.title, undefined, { numeric: true })
    );

  const toggleSort = () => {
    setIsAscending((prev) => !prev);
  };

  return (
    <div className="mx-auto max-w-6xl px-2 sm:px-6 lg:px-4">
      {/* Header */}
      <div className="mb-8">
        <h2 className="text-left text-base font-semibold text-sky-600 font-heading ">
          {fishingClubIntro.heading}
        </h2>
        <h3 className="mt-2 text-left text-2xl font-semibold tracking-tight text-gray-950 font-heading">
          {fishingClubIntro.subheading}
        </h3>

        {/* Dynamically loaded intro text */}
        <p className="mt-4 text-left text-base text-gray-700 whitespace-pre-line font-body sm:text-lg">
          {fishingClubIntro.introText}
        </p>

        {/* Buttons container */}
        <div className="mt-4 flex flex-wrap gap-4 items-center">
          {/* YouTube Playlist Button */}
          <a
            href="https://www.youtube.com/watch?v=pnKkYZ2k70A&list=PLU6GFGwHsfqVmfrOPYiCH6Rs6PLlD0MWK"
            target="_blank"
            rel="noopener noreferrer"
            className="font-body inline-flex items-center gap-x-2 py-2 px-4 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-full focus:outline-none group transition"
          >
            <FaYoutube className="transition-transform transform group-hover:scale-110 font-body" />
            Vereinsgeschichte auf YouTube
          </a>

          {/* Sortier-Button */}
          <button
            onClick={toggleSort}
            className="font-body inline-flex items-center gap-x-2 py-2 px-4 bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium rounded-full focus:outline-none group transition"
          >
            {isAscending ? (
                            <>
                <FaSortAmountDown className="font-body transition-transform transform group-hover:-rotate-4 group-hover:scale-110" />
                Geschichte absteigend sortieren
              </>

            ) : (
              <>
                <FaSortAmountUp className="font-body transition-transform transform group-hover:rotate-4 group-hover:scale-110" />
                Geschichte aufsteigend sortieren
              </>
            )}
          </button>
        </div>
      </div>

      {/* Timeline container */}
      <ol className="relative border-s border-sky-600 pb-10 ml-2">
        {sortedData.map((item, index) => (
          <li key={index} className="mb-10 ms-6">
            <span className="absolute flex items-center justify-center w-6 h-6 bg-sky-100 rounded-full -start-3 ring-8 ring-white">
              <FaFish className="w-3.5 h-3.5 text-blue-700" />
            </span>
            <h3 className="mb-2 text-lg font-semibold text-gray-900 font-heading">{item.title}</h3>
            {item.date && (
              <time className="block mb-2 text-sm font-normal leading-none text-gray-500 font-heading">
                {item.date}
              </time>
            )}
            <p className="text-base font-normal text-gray-600 whitespace-pre-line font-body">{item.content}</p>
          </li>
        ))}
      </ol>
    </div>
  );
};
